<template>
  <g :id="hand.id">
    <template v-if="hand.parent === 'A-22'">
      <path fill="#231F20" d="M73.1717,87.9171c0.5565,0.6573,0.4749,1.6411-0.1824,2.1977c-0.6573,0.5565-1.6412,0.4747-2.1977-0.1824
    c-0.5565-0.6573-0.4748-1.6412,0.1824-2.1977c0.0001-0.0001,0.0003-0.0002,0.0005-0.0004
    C71.6318,87.1782,72.6153,87.2601,73.1717,87.9171z M71.5541,88.4192c-0.2789,0.236-0.3137,0.6533-0.0778,0.9323
    c0.236,0.2789,0.6534,0.3137,0.9323,0.0778c0.2789-0.236,0.3137-0.6534,0.0778-0.9323c-0.2358-0.2789-0.6531-0.3138-0.9319-0.078
    C71.5544,88.419,71.5543,88.4192,71.5541,88.4192z"/>
      <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="71.9681" y1="87.3654" x2="72" y2="76.1712"/>
    </template>
    <template v-else-if="hand.parent === 'A-36'">
      <path fill="#231F20" d="M52.573,108.0806c1.0657,0.2559,1.7221,1.3272,1.4663,2.3928c-0.2559,1.0657-1.3272,1.7221-2.3928,1.4663
      s-1.7221-1.3272-1.4663-2.3928c0-0.0001,0-0.0002,0.0001-0.0003C50.4363,108.4811,51.5075,107.8248,52.573,108.0806z
       M51.218,109.796c-0.1181,0.4922,0.1851,0.987,0.6774,1.105c0.4922,0.1181,0.987-0.1851,1.105-0.6774
      c0.1181-0.4921-0.185-0.9866-0.677-1.1049C51.8313,109.0008,51.3365,109.3039,51.218,109.796z"/>
      <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="52.1033" y1="108.0256" x2="52.1304" y2="100.0734"/>
    </template>
  </g>
</template>

<script>
export default {
  name: 'sdHandChronoM',
  props: ['data'],
  computed: {
    hand() {
      if (this.data.hand) return this.data.hand;
    },
    watch() {
      if (this.data.watch) return this.data.watch;
    },
  },
};
</script>
